module.exports = __webpack_public_path__ + "img/earth.2f3e62e8.png";